import { defineComponent as _defineComponent } from 'vue'
import SidebarContent from '@/components/SidebarContent.vue';
import BCXSidebarAsLayer from '@/components/molecules/BCXSidebarAsLayer.vue';
import { useVModel } from '@vueuse/core';
import { PropType, ref } from 'vue';
import { InfoBoxType } from '@/models/InfoBox';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXSidebarOrLayer',
  props: {
  inBox: Boolean,
  isActive: Boolean,
  hasBackButton: Boolean,
  title: {
    type: String, default: ''
  },
  infoBoxType: {
    type: String as PropType<InfoBoxType>,
    default: InfoBoxType.INFOBOX_STANDARD
  },
  isAlwaysVisibleOnPage: Boolean,
},
  setup(__props) {

const props = __props;



const { isSidebarVisible } = useResponsiveness();

const isSidebarOpen = ref(true);

const isActive = useVModel(props, 'isActive');


return { __sfc: true,props, isSidebarVisible, isSidebarOpen, isActive, SidebarContent, BCXSidebarAsLayer }
}

})